/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import Tysiav2Spinner from 'DesignSystem/Svgs/Tysiav2Spinner/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LoadingSpinner/Content",
  height,
  width
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-Z1Yf8zk': typeof height === 'number' ? `${height}px` : height,'--w-2-Z1Yf8zk': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2Spinner
  viewPath={`${viewPath}/Tysiav2Spinner`}
 height={height}
 width={width}
/>
</div>
{children}
</React.Fragment>)
}